export default "__VITE_ASSET__uCNH9Hl1__"